import {inject, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Pipe({name: 'mentionRenderer', pure: true, standalone: true})
export class MentionRendererPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(text: string): SafeHtml {
    const escaped = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const html = escaped
      .replace(/@\[([^\]]+)\]/g, '<span class="mention-user">@$1</span>')
      .replace(/#\[([^\]]+)\]/g, '<span class="mention-todo">#$1</span>');

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
